module.exports = __webpack_public_path__ + "img/no-top.52c20b2c.png";